import { gql } from 'apollo-angular';

import {
  NOTE_OBJECT,
  PAYMENT_INVOICE_OBJECT,
  QUOTATIONS_OBJECT,
} from '../../../../@graphql/operations/fragment';

export {
  GET_INVOICE_PAYMENTS,
  GET_PAYMENT_BYID,
  GET_ALLPAYMENTS,
} from '../../../../@graphql/operations/query';

export {
  CREATE_INVOICE_PAYMENTS,
  REMOVE_INVOICE_PAYMENTS,
  ASSING_PAYMENTS,
  UPDATE_PAYMENT_STATUS,
  SEND_PAYMENT_MAIL,
} from '../../../../@graphql/operations/mutation';

export const GET_ALL_AR_INVOICES = gql`
  query getAllArInvoices($year: Int, $id_user: Int, $company: String) {
    getAllArInvoices(year: $year, id_user: $id_user, company: $company) {
      ...QuotationsObject
    }
  }
  ${QUOTATIONS_OBJECT}
`;

export const GET_ALL_AR_NOTES = gql`
  query getAllArNotes($year: Int, $company: String) {
    getAllArNotes(year: $year, company: $company) {
      ...NoteObject
    }
  }
  ${NOTE_OBJECT}
`;

export const GET_ALL_AR_INVOICEPAYMENTS = gql`
  query getAllArInvoicePayments($year: Int, $company: String) {
    getAllArInvoicePayments(year: $year, company: $company) {
      ...PayInvoiceObject
    }
  }
  ${PAYMENT_INVOICE_OBJECT}
`;
